module.exports = __webpack_public_path__ + "public/SiteIcons/gobalIcon.svg?f15332a3";